module.exports = __webpack_public_path__ + "static/img/1.3cf60bf4.png";